<template>
  <div>
    <a-row class="mb-20" style="margin-bottom: 20px">
      <a-col :xs="24" :sm="24" :md="8">
        <a-input-search
          style="width: 100%"
          :placeholder="$t('userManager.search')"
          enter-button
          @search="onSearch"
        />
      </a-col>
      <a-col :xs="24" :sm="24" :md="{span: 2, offset: 13}">
        <a-button type="primary" icon="plus" @click="handleCreate">
          {{ $t('table.create') }}
        </a-button>
      </a-col>
    </a-row>
    <a-divider />
    <a-row>
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="record">
          <a-button type="primary" icon="form" size="small" @click="handleEdit(record)">{{ $t('table.update') }}</a-button>
          <a-divider type="vertical" />
          <a-button type="danger" icon="delete" size="small" @click="confirmDelete(record)">{{ $t('table.delete') }}</a-button>
        </span>
      </a-table>
    </a-row>
    <AddEditModal ref="refModal" @updateUserSuccess="handleUpdateUserSuccess" />
  </div>
</template>

<script>
import {
  SearchUser as ApiSearchUser,
  DestroyUser as ApiDestroyUser
} from '@/api/users';
import AddEditModal from './AddEditModal.vue';
import formatDate from '@/utils/formatDateTime';

export default {
  name: 'Accounts',
  components: {
    AddEditModal
  },
  data() {
    const columns = [
      {
        dataIndex: 'name',
        title: () => this.$t('userManager.column.name'),
        key: 'name'
      },
      {
        dataIndex: 'email',
        title: () => this.$t('userManager.column.email'),
        key: 'email'
      },
      {
        dataIndex: 'tel',
        title: () => this.$t('userManager.column.telephone'),
        key: 'tel'
      },
      {
        dataIndex: 'birthday',
        title: () => this.$t('userManager.column.birthday'),
        key: 'birthday'
      },
      {
        title: this.$t('table.action'),
        key: 'action',
        width: '200px',
        scopedSlots: { customRender: 'action' }
      }
    ];
    return {
      columns,
      data: [],
      pagination: { current: 1, pageSize: 15 },
      filter: {},
      params: {},
      loading: false,
      form: this.$form.createForm(this)
    };
  },
  created() {
    this.handleSearch();
  },
  methods: {
    onSearch(value) {
      this.filter.name = value;
      this.handleSearch();
    },
    handleSearch() {
      this.loading = true;
      this.params.filter = this.filter || {};
      this.params.page = this.pagination.current || 1;
      ApiSearchUser(this.params)
        .then((response) => {
          const { data, pagination } = response;
          this.data = this.convertDateTime(data);
          this.pagination = {
            total: pagination.total,
            pageSize: pagination.perPage,
            current: pagination.currentPage
          };
          this.loading = false;
        })
        .catch(() => { this.loading = false; });
    },
    handleTableChange(pagination) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.handleSearch();
    },
    handleCreate() {
      this.$refs.refModal.showModal();
    },
    handleEdit(row) {
      this.$refs.refModal.showModal(row.id);
    },
    handleUpdateUserSuccess() {
      this.handleSearch();
    },
    confirmDelete(record) {
      this.$confirm({
        title: this.$t('modal.confirmDelete.question'),
        okText: this.$t('modal.confirmDelete.ok'),
        cancelText: this.$t('modal.confirmDelete.cancel'),
        onOk: () => {
          const { id } = record;
          return new Promise((resolve, reject) => {
            ApiDestroyUser({ id })
              .then(() => {
                this.$notification.success({
                  message: this.$t('modal.successMessage.deleteSuccess')
                });
                this.searchUser();
                resolve();
              })
              .catch(() => { reject(); });
          });
        }
      });
    },
    convertDateTime(data) {
      data.forEach((item, index) => {
        item.birthday = item.birthday ? formatDate(item.birthday) : '';
      });
      return data;
    }
  }
};
</script>
